export default __webpack_public_path__ + "static/media/FUNDING.416fc6cd.png";